// import { Icon } from "@iconify/react/dist/iconify.js";
// import { CheckCircle, Eye, EyeOff, Key } from "lucide-react";
// import React, { useEffect, useState, useCallback, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { apiCall } from "../Apis/apiCall";
// import Lottie from "lottie-react";
// import LoadingComponent from "./ui/LoadingComponent";
// import { handleApiResponse, handleCustomResponse } from "../utils/response";
// import CustomPhoneInput from "./ui/CustomPhoneInput";
// import { useForm } from "react-hook-form";
// import CustomSelect from "./ui/CustomSelect";

// const AddClient = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [plans, setPlans] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [productsLoading, setProductsLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const { control, formState: { errors }, setValue } = useForm();
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const navigate = useNavigate();

//   // Add debounce timers ref
//   const emailTimerRef = useRef(null);
//   const phoneTimerRef = useRef(null);
  
//   // Add validation results state
//   const [validationResults, setValidationResults] = useState({
//     email: { isValid: null, message: "", validating: false },
//     phone: { isValid: null, message: "", validating: false }
//   });

//   const [formData, setFormData] = useState({
//     companyName: "",
//     clientName: "",
//     email: "",
//     password: "",
//     confirmPassword: "",
//     phoneNumber: "",
//     clientType: "corporate",
//     logo: null,
//     selectedPlan: null,
//     selectedProduct: null,
//   });

//   // Real-time email validation with debounce
//   const validateEmailUnique = useCallback(async (email) => {
//     if (!email) {
//       setValidationResults(prev => ({
//         ...prev,
//         email: { isValid: null, message: "", validating: false }
//       }));
//       return;
//     }
    
//     // Basic email format check
//     if (!/^\S+@\S+\.\S+$/.test(email)) {
//       setValidationResults(prev => ({
//         ...prev,
//         email: { isValid: false, message: "✗ Invalid email format", validating: false }
//       }));
//       return;
//     }
    
//     setValidationResults(prev => ({
//       ...prev,
//       email: { ...prev.email, validating: true }
//     }));
    
//     try {
//       const response = await apiCall("post", "/validate-client-unique", {
//         email: email,
//         phone_no: ""
//       });
      
//       setValidationResults(prev => ({
//         ...prev,
//         email: { isValid: true, message: "", validating: false }
//       }));
//     } catch (error) {
//       const errorData = error.response?.data;
      
//       if (errorData?.errors?.email) {
//         setValidationResults(prev => ({
//           ...prev,
//           email: { isValid: false, message: "✗ Email is already registered", validating: false }
//         }));
//       } else {
//         setValidationResults(prev => ({
//           ...prev,
//           email: { 
//             isValid: false, 
//             message: errorData?.message || "✗ Validation failed", 
//             validating: false 
//           }
//         }));
//       }
//     }
//   }, []);

//   // Real-time phone validation with debounce
//   const validatePhoneUnique = useCallback(async (phoneNumber) => {
//     if (!phoneNumber) {
//       setValidationResults(prev => ({
//         ...prev,
//         phone: { isValid: null, message: "", validating: false }
//       }));
//       return;
//     }
    
//     // Basic phone length check
//     if (phoneNumber.length < 8) {
//       setValidationResults(prev => ({
//         ...prev,
//         phone: { isValid: false, message: "✗ Phone must be 8+ digits", validating: false }
//       }));
//       return;
//     }
    
//     setValidationResults(prev => ({
//       ...prev,
//       phone: { ...prev.phone, validating: true }
//     }));
    
//     try {
//       const response = await apiCall("post", "/validate-client-unique", {
//         email: "",
//         phone_no: phoneNumber
//       });
      
//       setValidationResults(prev => ({
//         ...prev,
//         phone: { isValid: true, message: "", validating: false }
//       }));
//     } catch (error) {
//       const errorData = error.response?.data;
      
//       if (errorData?.errors?.phone_no) {
//         setValidationResults(prev => ({
//           ...prev,
//           phone: { isValid: false, message: "✗ Phone is already registered", validating: false }
//         }));
//       } else {
//         setValidationResults(prev => ({
//           ...prev,
//           phone: { 
//             isValid: false, 
//             message: errorData?.message || "✗ Validation failed", 
//             validating: false 
//           }
//         }));
//       }
//     }
//   }, []);

//   // Handle input changes with real-time validation
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     setErrorMessage("");
    
//     // Real-time email validation
//     if (name === "email") {
//       // Clear previous timer
//       if (emailTimerRef.current) {
//         clearTimeout(emailTimerRef.current);
//       }
      
//       // Clear validation state while typing
//       setValidationResults(prev => ({
//         ...prev,
//         email: { isValid: null, message: "", validating: false }
//       }));
      
//       // Set new timer for debounce (500ms delay)
//       emailTimerRef.current = setTimeout(() => {
//         validateEmailUnique(value);
//       }, 500);
//     }
//   };

//   // Handle phone input changes with real-time validation
//   const handlePhoneChange = useCallback((phone) => {
//     setFormData({ ...formData, phoneNumber: phone });
//     setValue("phoneNumber", phone);
    
//     // Clear previous timer
//     if (phoneTimerRef.current) {
//       clearTimeout(phoneTimerRef.current);
//     }
    
//     // Clear validation state while typing
//     setValidationResults(prev => ({
//       ...prev,
//       phone: { isValid: null, message: "", validating: false }
//     }));
    
//     // Set new timer for debounce (500ms delay)
//     phoneTimerRef.current = setTimeout(() => {
//       validatePhoneUnique(phone);
//     }, 500);
//   }, [formData, setValue, validatePhoneUnique]);

//   // Handle file input and generate preview
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData({ ...formData, logo: file });
//     }
//     setErrorMessage("");
//   };

//   // Handle plan selection
//   const handlePlanSelect = (planId) => {
//     setFormData({ ...formData, selectedPlan: planId });
//     setErrorMessage("");
//   };

//   // Navigate steps
//   const nextStep = () => {
//     if (currentStep < 4) setCurrentStep(currentStep + 1);
//   };

//   const prevStep = () => {
//     if (currentStep > 1) setCurrentStep(currentStep - 1);
//   };

//   // Toggle password visibility for both fields
//   const togglePasswordVisibility = (field) => {
//     if (field === "password") setShowPassword((prev) => !prev);
//     else if (field === "confirmPassword")
//       setShowConfirmPassword((prev) => !prev);
//   };

//   // Generate random password
//   const generatePassword = () => {
//     const randomPassword =
//       Math.random().toString(36).slice(-12) +
//       Math.random().toString(36).slice(-6);
//     setFormData({
//       ...formData,
//       password: randomPassword,
//       confirmPassword: randomPassword,
//     });
//     setErrorMessage("");
//   };

//   // Original validation function (for backward compatibility)
//   const validateClientUnique = async (email, phoneNumber) => {
//     try {
//       const response = await apiCall("post", "/validate-client-unique", {
//         email: email,
//         phone_no: phoneNumber
//       });
      
//       return { isValid: true, message: "Email and phone are unique" };
//     } catch (error) {
//       const errorData = error.response?.data;
      
//       if (errorData?.errors) {
//         const errors = errorData.errors;
//         let errorMessage = "";
        
//         if (errors.email && errors.phone_no) {
//           errorMessage = "Email and phone number are already registered";
//         } else if (errors.email) {
//           errorMessage = "Email is already registered";
//         } else if (errors.phone_no) {
//           errorMessage = "Phone number is already registered";
//         }
        
//         return { isValid: false, message: errorMessage };
//       }
      
//       return { 
//         isValid: false, 
//         message: errorData?.message || "Validation failed. Please try again." 
//       };
//     }
//   };

//   // Fetch products
//   const fetchProducts = async () => {
//     try {
//       setProductsLoading(true);
//       const response = await apiCall("get", "/get-all-products", null, navigate);

//       console.log("Products API Response:", response);

//       if (response?.data?.success && response?.data?.data) {
//         setProducts(response.data.data);
//         console.log("Products loaded:", response.data.data);
        
//         if (response.data.data.length > 0) {
//           setFormData({ ...formData, selectedProduct: response.data.data[0].product_id });
//         }
//         const handleRes = response.data;
//         handleApiResponse(handleRes, "success", "GET");
//       } else {
//         console.log("Products fetch failed:", response);
//         handleCustomResponse("error", "Failed to load products.");
//       }
//     } catch (error) {
//       console.error("Products fetch error:", error);
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "GET");
//     } finally {
//       setProductsLoading(false);
//     }
//   };

//   // Updated fetchPlans function to accept productId
//   const fetchPlans = async (productId) => {
//     if (!productId) return;
//     try {
//       setLoading(true);
//       const response = await apiCall("get", `/get-pricing-plans-pev?product_id=${productId}`);

//       if (response?.data?.data) {
//         const fetchedPlans = response.data.data.map((plan) => ({
//           plan_id: plan.plan_id,
//           plan_name: plan.plan_name,
//           plan_type: plan.plan_type,
//           base_price: plan.base_price,
//           created_by: plan.created_by,
//           created_datetime: plan.created_datetime,
//           customer_segment: plan.customer_segment,
//           description: plan.description,
//           is_active: plan.is_active,
//           is_trial_plan: plan.is_trial_plan,
//           max_vehicle_count: plan.max_vehicle_count,
//           max_vehicles_allowed: plan.max_vehicles_allowed,
//           min_vehicle_count: plan.min_vehicle_count,
//           per_vehicle_fee: plan.per_vehicle_fee,
//           volume_threshold: plan.volume_threshold,
//         }));

//         setPlans(fetchedPlans);
//       } else {
//         handleCustomResponse("error", "No pricing plans available for this product.");
//       }
//     } catch (error) {
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "GET");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       setLoading(true);
//       setErrorMessage("");

//       const clientData = new FormData();
//       clientData.append("company_name", formData.companyName);
//       clientData.append("client_name", formData.clientName);
//       clientData.append("client_type", formData.clientType);
//       clientData.append("plan_id", parseInt(formData.selectedPlan, 10));
//       clientData.append("product_id", parseInt(formData.selectedProduct, 10));
//       clientData.append("email", formData.email);
//       clientData.append("phone_no", formData.phoneNumber);
//       clientData.append("password", formData.password);
//       if (formData.logo) {
//         clientData.append("logo", formData.logo);
//       }

//       const response = await apiCall(
//         "post",
//         "/create-client",
//         clientData,
//         navigate,
//         true
//       );

//       if (response?.data?.success) {
//         const handleRes = response.data;
//         handleApiResponse(handleRes, "success", "POST");
//         nextStep();
//       } else {
//         handleCustomResponse("error", "Failed to create client.");
//       }
//     } catch (error) {
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "POST");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Validate steps
//   const validateStep = async (step) => {
//     switch (step) {
//       case 1: {
//         const { companyName, clientName, email, phoneNumber, password, confirmPassword } = formData;
        
//         // Basic validation first
//         if (!companyName || !clientName || !email || !phoneNumber || !password) {
//           handleCustomResponse("error", "Please fill all required fields.");
//           return false;
//         }
        
//         if (!/^\S+@\S+\.\S+$/.test(email)) {
//           handleCustomResponse("error", "Invalid email address.");
//           return false;
//         }
        
//         if (!phoneNumber || phoneNumber.length < 8) {
//           handleCustomResponse("error", "Please enter a valid phone number.");
//           return false;
//         }
        
//         // Check real-time validation results
//         if (validationResults.email.isValid === false) {
//           handleCustomResponse("error", validationResults.email.message.replace("✗ ", ""));
//           return false;
//         }
        
//         if (validationResults.phone.isValid === false) {
//           handleCustomResponse("error", validationResults.phone.message.replace("✗ ", ""));
//           return false;
//         }
        
//         // If still validating, wait a bit
//         if (validationResults.email.validating || validationResults.phone.validating) {
//           handleCustomResponse("info", "Please wait while we validate your information...");
//           return false;
//         }
        
//         // If validation hasn't run yet, run it now
//         if (validationResults.email.isValid === null) {
//           await validateEmailUnique(email);
//           if (validationResults.email.isValid === false) {
//             handleCustomResponse("error", validationResults.email.message.replace("✗ ", ""));
//             return false;
//           }
//         }
        
//         if (validationResults.phone.isValid === null) {
//           await validatePhoneUnique(phoneNumber);
//           if (validationResults.phone.isValid === false) {
//             handleCustomResponse("error", validationResults.phone.message.replace("✗ ", ""));
//             return false;
//           }
//         }
        
//         if (password.length < 6) {
//           handleCustomResponse("error", "Password must be 6+ characters.");
//           return false;
//         }
        
//         if (password !== confirmPassword) {
//           handleCustomResponse("error", "Passwords do not match.");
//           return false;
//         }
        
//         return true;
//       }
//       case 2:
//         return true;
//       case 3:
//         if (!formData.selectedPlan || !formData.selectedProduct) {
//           handleCustomResponse("error", "Select a product and plan.");
//           return false;
//         }
//         return true;
//       case 4:
//         return true;
//       default:
//         return true;
//     }
//   };

//   // Handle next step
//   const handleNextStep = async () => {
//     const isValid = await validateStep(currentStep);
//     if (isValid) {
//       if (currentStep === 4) setShowConfirmModal(true);
//       else nextStep();
//     }
//   };

//   // Confirm submission
//   const confirmSubmission = () => {
//     setShowConfirmModal(false);
//     handleSubmit();
//   };

//   // Cleanup timers on unmount
//   useEffect(() => {
//     return () => {
//       if (emailTimerRef.current) {
//         clearTimeout(emailTimerRef.current);
//       }
//       if (phoneTimerRef.current) {
//         clearTimeout(phoneTimerRef.current);
//       }
//     };
//   }, []);

//   // Fetch products and plans
//   useEffect(() => {
//     if (currentStep === 2 && products.length === 0) {
//       fetchProducts();
//     }
//   }, [currentStep]);

//   // Fetch plans when selectedProduct changes
//   useEffect(() => {
//     if (currentStep === 2 && formData.selectedProduct) {
//       setPlans([]);
//       setFormData({ ...formData, selectedPlan: null });
//       fetchPlans(formData.selectedProduct);
//     }
//   }, [formData.selectedProduct, currentStep]);

//   // Get logo preview or backend URL
//   const getLogoPreview = () => {
//     if (formData.logo instanceof File) {
//       return URL.createObjectURL(formData.logo);
//     } else if (formData.logo && typeof formData.logo === "string") {
//       return `http://pevbackend.codovio.com/${formData.logo}`;
//     }
//     return "assets/images/user-list/user-list1.png";
//   };

//   return (
//     <>
//       <style>
//         {`
//         .container {
//           width: 100% !important;
//           max-width: 100% !important;
//           padding-left: 15px;
//           padding-right: 15px;
//           margin: 0 auto;
//         }
//         .card {
//           width: 100%;
//           max-width: 100%;
//         }
//         .form-wizard {
//           width: 100%;
//         }
//         @media (max-width: 576px) {
//           .container {
//             padding-left: 10px;
//             padding-right: 10px;
//           }
//         }
//         .modal-dialog {
//           max-width: min(400px, 90vw) !important;
//           margin: 1rem auto !important;
//         }
//         .pricing-plan {
//           width: 100%;
//         }
//         .validation-message {
//           font-size: 12px;
//           margin-top: 4px;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//         }
//         .is-valid {
//           border-color: #28a745 !important;
//         }
//         .is-invalid {
//           border-color: #dc3545 !important;
//         }
//         .validating-spinner {
//           display: inline-block;
//           width: 12px;
//           height: 12px;
//           border: 2px solid #ccc;
//           border-top-color: #007bff;
//           border-radius: 50%;
//           animation: spin 0.6s linear infinite;
//         }
//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }
//         .real-time-feedback {
//           position: absolute;
//           right: 10px;
//           top: 50%;
//           transform: translateY(-50%);
//         }
//       `}
//       </style>
//       <div className="container">
//         <div className="col">
//           <div className="">
//             <div className="card">
//               <div className="card-body">
//                 <h6 className="mb-4 text-xl">Add New Client</h6>
//                 <p className="text-neutral-500">
//                   Fill up your details and proceed next steps.
//                 </p>

//                 {/* Form Wizard Start */}
//                 <div className="form-wizard">
//                   <form action="#" method="post">
//                     <div className="form-wizard-header overflow-x-auto scroll-sm pb-8 my-32">
//                       <ul className="list-unstyled form-wizard-list style-two">
//                         <li
//                           className={`form-wizard-list__item ${
//                             [2, 3, 4].includes(currentStep) && "activated"
//                           } ${currentStep === 1 && "active"} `}
//                         >
//                           <div className="form-wizard-list__line">
//                             <span className="count">1</span>
//                           </div>
//                           <span className="text text-xs fw-semibold">
//                             Basic Info
//                           </span>
//                         </li>
//                         <li
//                           className={`form-wizard-list__item ${
//                             [3, 4].includes(currentStep) && "activated"
//                           } ${currentStep === 2 && "active"} `}
//                         >
//                           <div className="form-wizard-list__line">
//                             <span className="count">2</span>
//                           </div>
//                           <span className="text text-xs fw-semibold">
//                             Select Plan
//                           </span>
//                         </li>
//                         <li
//                           className={`form-wizard-list__item ${
//                             [4].includes(currentStep) && "activated"
//                           } ${currentStep === 3 && "active"} `}
//                         >
//                           <div className="form-wizard-list__line">
//                             <span className="count">3</span>
//                           </div>
//                           <span className="text text-xs fw-semibold">
//                             Review
//                           </span>
//                         </li>
//                         <li
//                           className={`form-wizard-list__item ${
//                             currentStep === 4 && "active"
//                           } `}
//                         >
//                           <div className="form-wizard-list__line">
//                             <span className="count">4</span>
//                           </div>
//                           <span className="text text-xs fw-semibold">
//                             Completed
//                           </span>
//                         </li>
//                       </ul>
//                     </div>
//                     {/* Step 1: Basic Information */}
//                     <fieldset
//                       className={`wizard-fieldset ${
//                         currentStep === 1 && "show"
//                       } `}
//                     >
//                       <h6 className="text-md text-neutral-500">
//                         Basic Information
//                       </h6>
//                       <div className="row gy-3">
//                         <div className="col-12">
//                           <label className="form-label">Company Name*</label>
//                           <div className="position-relative">
//                             <input
//                               type="text"
//                               className="form-control wizard-required"
//                               placeholder="Enter Company Name"
//                               name="companyName"
//                               value={formData.companyName}
//                               onChange={handleInputChange}
//                               required
//                             />
//                             <div className="wizard-form-error" />
//                           </div>
//                         </div>
//                         <div className="col-12">
//                           <label className="form-label">Client Name*</label>
//                           <div className="position-relative">
//                             <input
//                               type="text"
//                               className="form-control wizard-required"
//                               placeholder="Enter Client Name"
//                               name="clientName"
//                               value={formData.clientName}
//                               onChange={handleInputChange}
//                               required
//                             />
//                             <div className="wizard-form-error" />
//                           </div>
//                         </div>
//                         <div className="col-12">
//                           <label className="form-label">Email*</label>
//                           <div className="position-relative">
//                             <input
//                               type="email"
//                               className={`form-control wizard-required ${
//                                 validationResults.email.isValid === true ? 'is-valid' :
//                                 validationResults.email.isValid === false ? 'is-invalid' : ''
//                               }`}
//                               placeholder="Enter Email"
//                               name="email"
//                               value={formData.email}
//                               onChange={handleInputChange}
//                               required
//                             />
//                             {validationResults.email.validating && (
//                               <div className="real-time-feedback">
//                                 <div className="validating-spinner"></div>
//                               </div>
//                             )}
//                             {validationResults.email.isValid === true && !validationResults.email.validating && (
//                               <div className="real-time-feedback text-success">
                                
//                               </div>
//                             )}
//                             {validationResults.email.isValid === false && !validationResults.email.validating && (
//                               <div className="real-time-feedback text-danger">
                                
//                               </div>
//                             )}
//                             <div className="wizard-form-error" />
//                           </div>
//                           {validationResults.email.message && (
//                             <div className={`validation-message ${
//                               validationResults.email.isValid === true ? 'text-success' :
//                               validationResults.email.isValid === false ? 'text-danger' : 'text-muted'
//                             }`}>
//                               {validationResults.email.validating ? (
//                                 <>
//                                   <div className="validating-spinner"></div>
//                                   Checking email availability...
//                                 </>
//                               ) : (
//                                 validationResults.email.message
//                               )}
//                             </div>
//                           )}
//                         </div>
//                         <div className="col-12">
//                           {/* <label className="form-label">Phone Number*</label> */}
//                           <div className="position-relative">
//                             <CustomPhoneInput
//                               name="phoneNumber"
//                               control={control}
//                               errors={errors}
//                               defaultCountry="pk"
//                               placeholder="Enter phone number"
//                               value={formData.phoneNumber}
//                               onChange={handlePhoneChange}
//                               className={`w-100 ${
//                                 validationResults.phone.isValid === true ? 'is-valid' :
//                                 validationResults.phone.isValid === false ? 'is-invalid' : ''
//                               }`}
//                             />
//                             {validationResults.phone.validating && (
//                               <div className="real-time-feedback">
//                                 <div className="validating-spinner"></div>
//                               </div>
//                             )}
//                             {validationResults.phone.isValid === true && !validationResults.phone.validating && (
//                               <div className="real-time-feedback text-success">
                                
//                               </div>
//                             )}
//                             {validationResults.phone.isValid === false && !validationResults.phone.validating && (
//                               <div className="real-time-feedback text-danger">
                                
//                               </div>
//                             )}
//                           </div>
//                           {validationResults.phone.message && (
//                             <div className={`validation-message mt-1 ${
//                               validationResults.phone.isValid === true ? 'text-success' :
//                               validationResults.phone.isValid === false ? 'text-danger' : 'text-muted'
//                             }`}>
//                               {validationResults.phone.validating ? (
//                                 <>
//                                   <div className="validating-spinner"></div>
//                                   Checking phone availability...
//                                 </>
//                               ) : (
//                                 validationResults.phone.message
//                               )}
//                             </div>
//                           )}
//                         </div>
//                         <div className="col-sm-6">
//                           <label className="form-label">Password*</label>
//                           <div className="position-relative">
//                             <input
//                               type={showPassword ? "text" : "password"}
//                               className="form-control wizard-required pr-16"
//                               placeholder="Enter Password"
//                               name="password"
//                               value={formData.password}
//                               onChange={handleInputChange}
//                               required
//                             />
//                             <span
//                               onClick={generatePassword}
//                               style={{
//                                 position: "absolute",
//                                 right: "10px",
//                                 top: "50%",
//                                 transform: "translateY(-50%)",
//                                 cursor: "pointer",
//                                 color: "#666",
//                               }}
//                             >
//                               <Key size={18} />
//                             </span>
//                             <span
//                               onClick={() =>
//                                 togglePasswordVisibility("password")
//                               }
//                               style={{
//                                 position: "absolute",
//                                 right: "40px",
//                                 top: "50%",
//                                 transform: "translateY(-50%)",
//                                 cursor: "pointer",
//                                 color: "#666",
//                               }}
//                             >
//                               {showPassword ? (
//                                 <EyeOff size={18} />
//                               ) : (
//                                 <Eye size={18} />
//                               )}
//                             </span>
//                             <div className="wizard-form-error" />
//                           </div>
//                           <small className="text-muted">
//                             Password should be 6 characters long
//                           </small>
//                         </div>
//                         <div className="col-sm-6">
//                           <label className="form-label">
//                             Confirm Password*
//                           </label>
//                           <div className="position-relative">
//                             <input
//                               type={showConfirmPassword ? "text" : "password"}
//                               className="form-control wizard-required pr-10"
//                               placeholder="Confirm Password"
//                               name="confirmPassword"
//                               value={formData.confirmPassword}
//                               onChange={handleInputChange}
//                               required
//                             />
//                             <span
//                               onClick={() =>
//                                 togglePasswordVisibility("confirmPassword")
//                               }
//                               style={{
//                                 position: "absolute",
//                                 right: "10px",
//                                 top: "50%",
//                                 transform: "translateY(-50%)",
//                                 cursor: "pointer",
//                                 color: "#666",
//                               }}
//                             >
//                               {showConfirmPassword ? (
//                                 <EyeOff size={18} />
//                               ) : (
//                                 <Eye size={18} />
//                               )}
//                             </span>
//                             <div className="wizard-form-error" />
//                           </div>
//                         </div>
//                         <div className="col-12">
//                           <label className="form-label">Logo (Optional)</label>
//                           <div className="position-relative">
//                             <input
//                               type="file"
//                               className="form-control wizard-required"
//                               accept="image/*"
//                               onChange={handleFileChange}
//                             />
//                             <div className="wizard-form-error" />
//                           </div>
//                           {formData.logo && (
//                             <div className="mt-2">
//                               <p className="text-neutral-500 small mb-2">
//                                 Selected: {formData.logo.name}
//                               </p>
//                               <img
//                                 src={getLogoPreview()}
//                                 alt="Logo Preview"
//                                 style={{
//                                   maxWidth: "150px",
//                                   maxHeight: "150px",
//                                   borderRadius: "8px",
//                                 }}
//                               />
//                             </div>
//                           )}
//                         </div>
//                         <div className="form-group text-end">
//                           <button
//                             onClick={handleNextStep}
//                             type="button"
//                             className="form-wizard-next-btn btn btn-primary-600 px-32"
//                             disabled={loading || validationResults.email.validating || validationResults.phone.validating}
//                           >
//                             Next
//                           </button>
//                         </div>
//                       </div>
//                     </fieldset>
//                     {/* Step 2: Select Product & Plan */}
//                     <fieldset
//                       className={`wizard-fieldset ${
//                         currentStep === 2 && "show"
//                       } `}
//                     >
//                       <h6 className="text-md text-neutral-500">Select Plan</h6>
//                       <div className="row gy-3">
//                        <div className="col-12">
//                           <label className="form-label">Select Product*</label>
//                           <div className={errorMessage ? "is-invalid" : ""}>
//                             <CustomSelect
//                               name="selectedProduct"
//                               value={
//                                 formData.selectedProduct
//                                   ? products.find(p => p.product_id === formData.selectedProduct)
//                                     ? { 
//                                         label: products.find(p => p.product_id === formData.selectedProduct)?.product_name, 
//                                         value: formData.selectedProduct 
//                                       }
//                                     : null
//                                   : null
//                               }
//                               onChange={(selectedOption) => {
//                                 handleInputChange({
//                                   target: { name: "selectedProduct", value: selectedOption?.value || "" }
//                                 });
//                               }}
//                               options={products.map(product => ({
//                                 label: product.product_name,
//                                 value: product.product_id,
//                                 raw: product
//                               }))}
//                               placeholder="Select a product"
//                               labelKey="label"
//                               valueKey="value"
//                               isClearable={false}
//                               isSearchable={true}
//                               isLoading={productsLoading || loading}
//                             />
//                             {errorMessage && (
//                               <span className="text-danger-600 d-block mt-1">{errorMessage}</span>
//                             )}
//                           </div>
//                         </div>
//                         {productsLoading ? (
//                           <div className="text-center my-4">
//                             {/* <LoadingComponent /> */}
//                           </div>
//                         ) : loading ? (
//                           <div className="text-center my-4">
//                             {/* <LoadingComponent /> */}
//                           </div>
//                         ) : plans.length === 0 ? (
//                           <div className="alert alert-warning" role="alert">
//                             No plans available for this product. Select another product or contact support.
//                           </div>
//                         ) : (
//                           plans.map((plan) => (
//                             <div
//                               className="col-xxl-4 col-sm-6"
//                               key={plan.plan_id}
//                             >
//                               <div
//                                 className={`pricing-plan position-relative radius-24 overflow-hidden border 
//                               ${
//                                 formData.selectedPlan === plan.plan_id
//                                   ? "bg-primary-600 text-white"
//                                   : "bg-base"
//                               }`}
//                                 onClick={() => handlePlanSelect(plan.plan_id)}
//                                 style={{
//                                   cursor: "pointer",
//                                   transition: "0.3s",
//                                 }}
//                               >
//                                 {formData.selectedPlan === plan.plan_id && (
//                                   <span className="bg-white bg-opacity-25 text-white radius-24 py-8 px-24 text-sm position-absolute end-0 top-0 z-1 rounded-start-top-0 rounded-end-bottom-0">
//                                     Selected
//                                   </span>
//                                 )}

//                                 <div className="d-flex align-items-center gap-16 p-24">
//                                   <span
//                                     className={`w-72-px h-72-px d-flex justify-content-center align-items-center radius-16 
//                                 ${
//                                   formData.selectedPlan === plan.plan_id
//                                     ? "bg-base"
//                                     : "bg-primary-50"
//                                 }`}
//                                   >
//                                     <img
//                                       src="/assets/images/pricing/price-icon4.png"
//                                       alt="plan-icon"
//                                     />
//                                   </span>
//                                   <div>
//                                     <span
//                                       className={`fw-medium text-md ${
//                                         formData.selectedPlan === plan.plan_id
//                                           ? "text-white"
//                                           : "text-secondary-light"
//                                       }`}
//                                     >
//                                       {plan.plan_type}
//                                     </span>
//                                     <h6
//                                       className={`mb-0 ${
//                                         formData.selectedPlan === plan.plan_id
//                                           ? "text-white"
//                                           : ""
//                                       }`}
//                                     >
//                                       {plan.plan_name}
//                                     </h6>
//                                   </div>
//                                 </div>

//                                 <div className="px-24">
//                                   <p
//                                     className={`mt-16 mb-0 ${
//                                       formData.selectedPlan === plan.plan_id
//                                         ? "text-white"
//                                         : "text-secondary-light"
//                                     } mb-28`}
//                                   >
//                                     {plan.description ||
//                                       "No description available."}
//                                   </p>

//                                   <h3
//                                     className={`mb-24 ${
//                                       formData.selectedPlan === plan.plan_id
//                                         ? "text-white"
//                                         : ""
//                                     }`}
//                                   >
//                                     ${plan.base_price}{" "}
//                                     <span
//                                       className={`fw-medium text-md ${
//                                         formData.selectedPlan === plan.plan_id
//                                           ? "text-white"
//                                           : "text-secondary-light"
//                                       }`}
//                                     >
//                                       /monthly
//                                     </span>
//                                   </h3>

//                                   <span
//                                     className={`mb-20 fw-medium ${
//                                       formData.selectedPlan === plan.plan_id
//                                         ? "text-white"
//                                         : ""
//                                     }`}
//                                   >
//                                     Plan Details
//                                   </span>
//                                   <ul className="mt-2">
//                                     {[
//                                       { label: "Plan ID", value: plan.plan_id },
//                                       {
//                                         label: "Created By",
//                                         value: plan.created_by,
//                                       },
//                                       {
//                                         label: "Created Date",
//                                         value: plan.created_datetime,
//                                       },
//                                       {
//                                         label: "Customer Segment",
//                                         value: plan.customer_segment,
//                                       },
//                                       {
//                                         label: "Active",
//                                         value: plan.is_active ? "Yes" : "No",
//                                       },
//                                       {
//                                         label: "Trial Plan",
//                                         value: plan.is_trial_plan
//                                           ? "Yes"
//                                           : "No",
//                                       },
//                                       {
//                                         label: "Max Vehicle Count",
//                                         value: plan.max_vehicle_count,
//                                       },
//                                       {
//                                         label: "Max Vehicles Allowed",
//                                         value: plan.max_vehicles_allowed,
//                                       },
//                                       {
//                                         label: "Min Vehicle Count",
//                                         value: plan.min_vehicle_count,
//                                       },
//                                       {
//                                         label: "Per Vehicle Fee",
//                                         value: plan.per_vehicle_fee
//                                           ? `$${plan.per_vehicle_fee}`
//                                           : "N/A",
//                                       },
//                                       {
//                                         label: "Volume Threshold",
//                                         value: plan.volume_threshold || "N/A",
//                                       },
//                                     ].map((item, idx) => (
//                                       <li
//                                         key={idx}
//                                         className="d-flex align-items-center gap-16 mb-12 text-lg"
//                                       >
//                                         <span
//                                           className={`w-24-px h-24-px d-flex justify-content-center align-items-center rounded-circle 
//                                       ${
//                                         formData.selectedPlan === plan.plan_id
//                                           ? "bg-white text-primary-600"
//                                           : "bg-primary-600 text-white"
//                                       }`}
//                                         >
//                                           <i className="bi bi-check"></i>
//                                         </span>
//                                         <span
//                                           className={`${
//                                             formData.selectedPlan ===
//                                             plan.plan_id
//                                               ? "text-white"
//                                               : "text-secondary-light"
//                                           } text-sm`}
//                                         >
//                                           <strong>{item.label}:</strong>{" "}
//                                           {item.value}
//                                         </span>
//                                       </li>
//                                     ))}
//                                   </ul>
//                                 </div>
//                               </div>
//                             </div>
//                           ))
//                         )}
//                         <div className="form-group d-flex align-items-center justify-content-end gap-8">
//                           <button
//                             onClick={prevStep}
//                             type="button"
//                             className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32"
//                             disabled={loading || productsLoading}
//                           >
//                             Back
//                           </button>
//                           <button
//                             onClick={handleNextStep}
//                             type="button"
//                             className="form-wizard-next-btn btn btn-primary-600 px-32"
//                             disabled={!formData.selectedPlan || loading || productsLoading}
//                           >
//                             Next
//                           </button>
//                         </div>
//                       </div>
//                     </fieldset>
//                     {/* Step 3: Review */}
//                     <fieldset
//                       className={`wizard-fieldset ${
//                         currentStep === 3 && "show"
//                       } `}
//                     >
//                       <h6 className="text-md text-neutral-500">
//                         Review Information
//                       </h6>
//                       <div className="row gy-3">
//                         <div className="col-12">
//                           <div className="card border-neutral-100">
//                             <div className="card-body">
//                               <h6 className="text-md text-neutral-500">
//                                 Basic Information
//                               </h6>
//                               <div className="row mb-2">
//                                 <div className="col-6 text-neutral-500">
//                                   Company Name:
//                                 </div>
//                                 <div className="col-6">
//                                   {formData.companyName}
//                                 </div>
//                               </div>
//                               <div className="row mb-2">
//                                 <div className="col-6 text-neutral-500">
//                                   Client Name:
//                                 </div>
//                                 <div className="col-6">
//                                   {formData.clientName}
//                                 </div>
//                               </div>
//                               <div className="row mb-2">
//                                 <div className="col-6 text-neutral-500">
//                                   Email:
//                                 </div>
//                                 <div className="col-6">
//                                   {formData.email}
//                                   {validationResults.email.isValid === true && (
//                                     <span className="text-success ms-2">✓ Verified</span>
//                                   )}
//                                 </div>
//                               </div>
//                               <div className="row mb-2">
//                                 <div className="col-6 text-neutral-500">
//                                   Phone Number:
//                                 </div>
//                                 <div className="col-6">
//                                   {formData.phoneNumber}
//                                   {validationResults.phone.isValid === true && (
//                                     <span className="text-success ms-2">✓ Verified</span>
//                                   )}
//                                 </div>
//                               </div>
//                               <div className="row mb-2">
//                                 <div className="col-6 text-neutral-500">
//                                   Client Type:
//                                 </div>
//                                 <div className="col-6">
//                                   {formData.clientType === "corporate"
//                                     ? "Corporate"
//                                     : "Individual"}
//                                 </div>
//                               </div>
//                               <div className="row mb-2">
//                                 <div className="col-6 text-neutral-500">
//                                   Logo:
//                                 </div>
//                                 <div className="col-6">
//                                   {formData.logo ? (
//                                     <img
//                                       src={getLogoPreview()}
//                                       alt="Logo Preview"
//                                       style={{
//                                         maxWidth: "150px",
//                                         maxHeight: "150px",
//                                         borderRadius: "8px",
//                                       }}
//                                     />
//                                   ) : (
//                                     "None"
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="col-12">
//                           <div className="card border-neutral-100">
//                             <div className="card-body">
//                               <h6 className="text-md text-neutral-500">
//                                 Selected Product & Plan
//                               </h6>
//                               {formData.selectedProduct && (
//                                 <>
//                                   <div className="row mb-2">
//                                     <div className="col-6 text-neutral-500">
//                                       Product Name:
//                                     </div>
//                                     <div className="col-6">
//                                       {
//                                         products.find(
//                                           (p) =>
//                                             p.product_id === formData.selectedProduct
//                                         )?.product_name
//                                       }
//                                     </div>
//                                   </div>
//                                 </>
//                               )}
//                               {formData.selectedPlan && (
//                                 <>
//                                   <div className="row mb-2">
//                                     <div className="col-6 text-neutral-500">
//                                       Plan Name:
//                                     </div>
//                                     <div className="col-6">
//                                       {
//                                         plans.find(
//                                           (p) =>
//                                             p.plan_id === formData.selectedPlan
//                                         )?.plan_name
//                                       }
//                                     </div>
//                                   </div>
//                                   <div className="row mb-2">
//                                     <div className="col-6 text-neutral-500">
//                                       Price:
//                                     </div>
//                                     <div className="col-6">
//                                       $
//                                       {
//                                         plans.find(
//                                           (p) =>
//                                             p.plan_id === formData.selectedPlan
//                                         )?.base_price
//                                       }
//                                     </div>
//                                   </div>
//                                 </>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="form-group d-flex align-items-center justify-content-end gap-8">
//                           <button
//                             onClick={prevStep}
//                             type="button"
//                             className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32"
//                             disabled={loading}
//                           >
//                             Back
//                           </button>
//                           <button
//                             onClick={handleNextStep}
//                             type="button"
//                             className="form-wizard-next-btn btn btn-primary-600 px-32"
//                             disabled={loading}
//                           >
//                             Submit
//                           </button>
//                         </div>
//                       </div>
//                     </fieldset>
//                     {/* Step 4: Completed */}
//                     <fieldset
//                       className={`wizard-fieldset ${
//                         currentStep === 4 && "show"
//                       } `}
//                     >
//                       <div className="text-center mb-40">
//                         <img
//                           src="assets/images/gif/success-img3.gif"
//                           alt="Client Added"
//                           className="gif-image mb-24"
//                         />
//                         <h6 className="text-md text-neutral-600">
//                           Congratulations
//                         </h6>
//                         <p className="text-neutral-400 text-sm mb-0">
//                           Client added successfully!
//                         </p>
//                       </div>
//                       <div className="form-group d-flex align-items-center justify-content-end gap-8">
//                         <Link to="/">
//                           <button
//                             type="button"
//                             className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32"
//                           >
//                             Dashboard
//                           </button>
//                         </Link>
//                         <Link to="/all-clients">
//                           <button
//                             type="button"
//                             className="form-wizard-submit btn btn-primary-600 px-32"
//                           >
//                             Client List
//                           </button>
//                         </Link>
//                       </div>
//                     </fieldset>
//                   </form>
//                 </div>
//                 {/* Form Wizard End */}
//               </div>
//             </div>
//             {/* Confirmation Modal */}
//             <div
//               className={`modal fade ${showConfirmModal ? "show d-block" : ""}`}
//               style={{
//                 background: showConfirmModal ? "rgba(0,0,0,0.5)" : "none",
//               }}
//               tabIndex="-1"
//             >
//               <div className="modal-dialog modal-dialog-centered">
//                 <div className="modal-content">
//                   <div className="modal-header">
//                     <h5 className="modal-title">Confirm Submission</h5>
//                     <button
//                       type="button"
//                       className="btn-close"
//                       onClick={() => setShowConfirmModal(false)}
//                     ></button>
//                   </div>
//                   <div className="modal-body">
//                     Are you sure you want to submit? Please review all details.
//                   </div>
//                   <div className="modal-footer">
//                     <button
//                       type="button"
//                       className="btn btn-neutral-500 border-neutral-100"
//                       onClick={() => setShowConfirmModal(false)}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="button"
//                       className="btn btn-primary-600"
//                       onClick={confirmSubmission}
//                     >
//                       Confirm
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* Loading Overlay */}
//             {(loading || validationResults.email.validating || validationResults.phone.validating) && (
//               <div
//                 className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
//                 style={{ background: "rgba(0,0,0,0.6)", zIndex: 9999 }}
//               >
//                 <LoadingComponent />
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddClient;






















import { Icon } from "@iconify/react/dist/iconify.js";
import { CheckCircle, Eye, EyeOff, Key } from "lucide-react";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiCall } from "../Apis/apiCall";
import Lottie from "lottie-react";
import LoadingComponent from "./ui/LoadingComponent";
import { handleApiResponse, handleCustomResponse } from "../utils/response";
import CustomPhoneInput from "./ui/CustomPhoneInput";
import { useForm } from "react-hook-form";
import CustomSelect from "./ui/CustomSelect";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const AddClient = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [plans, setPlans] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { control, formState: { errors }, setValue } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  // Add debounce timers ref
  const emailTimerRef = useRef(null);
  const phoneTimerRef = useRef(null);
  
  // Add validation results state
  const [validationResults, setValidationResults] = useState({
    email: { isValid: null, message: "", validating: false },
    phone: { isValid: null, message: "", validating: false }
  });
  

  const [formData, setFormData] = useState({
    companyName: "",
    clientName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
    clientType: "corporate",
    logo: null,
    selectedPlan: null,
    selectedProduct: null,
  });

  // Real-time email validation with debounce
  const validateEmailUnique = useCallback(async (email) => {
    if (!email) {
      setValidationResults(prev => ({
        ...prev,
        email: { isValid: null, message: "", validating: false }
      }));
      return;
    }
    
    // Basic email format check
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setValidationResults(prev => ({
        ...prev,
        email: { isValid: false, message: "✗ Invalid email format", validating: false }
      }));
      return;
    }

    const passwordSchema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must contain at least one uppercase, lowercase, number & special character"
    ),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref('password')], 'Passwords do not match'),
});
    
    setValidationResults(prev => ({
      ...prev,
      email: { ...prev.email, validating: true }
    }));
    
    try {
      const response = await apiCall("post", "/validate-client-unique", {
        email: email,
        phone_no: ""
      });
      
      setValidationResults(prev => ({
        ...prev,
        email: { isValid: true, message: "", validating: false }
      }));
    } catch (error) {
      const errorData = error.response?.data;
      
      if (errorData?.errors?.email) {
        setValidationResults(prev => ({
          ...prev,
          email: { isValid: false, message: "✗ Email is already registered", validating: false }
        }));
      } else {
        setValidationResults(prev => ({
          ...prev,
          email: { 
            isValid: false, 
            message: errorData?.message || "✗ Validation failed", 
            validating: false 
          }
        }));
      }
    }
  }, []);

  // Real-time phone validation with debounce
  const validatePhoneUnique = useCallback(async (phoneNumber) => {
    if (!phoneNumber) {
      setValidationResults(prev => ({
        ...prev,
        phone: { isValid: null, message: "", validating: false }
      }));
      return;
    }
    
    // Basic phone length check
    if (phoneNumber.length < 8) {
      setValidationResults(prev => ({
        ...prev,
        phone: { isValid: false, message: "✗ Phone must be 8+ digits", validating: false }
      }));
      return;
    }
    
    setValidationResults(prev => ({
      ...prev,
      phone: { ...prev.phone, validating: true }
    }));
    
    try {
      const response = await apiCall("post", "/validate-client-unique", {
        email: "",
        phone_no: phoneNumber
      });
      
      setValidationResults(prev => ({
        ...prev,
        phone: { isValid: true, message: "", validating: false }
      }));
    } catch (error) {
      const errorData = error.response?.data;
      
      if (errorData?.errors?.phone_no) {
        setValidationResults(prev => ({
          ...prev,
          phone: { isValid: false, message: "✗ Phone is already registered", validating: false }
        }));
      } else {
        setValidationResults(prev => ({
          ...prev,
          phone: { 
            isValid: false, 
            message: errorData?.message || "✗ Validation failed", 
            validating: false 
          }
        }));
      }
    }
  }, []);

  // Handle input changes with real-time validation
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrorMessage("");
    
    // Real-time email validation
    if (name === "email") {
      // Clear previous timer
      if (emailTimerRef.current) {
        clearTimeout(emailTimerRef.current);
      }
      
      // Clear validation state while typing
      setValidationResults(prev => ({
        ...prev,
        email: { isValid: null, message: "", validating: false }
      }));
      
      // Set new timer for debounce (500ms delay)
      emailTimerRef.current = setTimeout(() => {
        validateEmailUnique(value);
      }, 500);
    }
  };

  // Handle phone input changes with real-time validation
  const handlePhoneChange = useCallback((phone) => {
    setFormData({ ...formData, phoneNumber: phone });
    setValue("phoneNumber", phone);
    
    // Clear previous timer
    if (phoneTimerRef.current) {
      clearTimeout(phoneTimerRef.current);
    }
    
    // Clear validation state while typing
    setValidationResults(prev => ({
      ...prev,
      phone: { isValid: null, message: "", validating: false }
    }));
    
    // Set new timer for debounce (500ms delay)
    phoneTimerRef.current = setTimeout(() => {
      validatePhoneUnique(phone);
    }, 500);
  }, [formData, setValue, validatePhoneUnique]);

  // Handle file input and generate preview
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, logo: file });
    }
    setErrorMessage("");
  };

  // Handle plan selection
  const handlePlanSelect = (planId) => {
    setFormData({ ...formData, selectedPlan: planId });
    setErrorMessage("");
  };

  // Navigate steps
  const nextStep = () => {
    if (currentStep < 4) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  // Toggle password visibility for both fields
  const togglePasswordVisibility = (field) => {
    if (field === "password") setShowPassword((prev) => !prev);
    else if (field === "confirmPassword")
      setShowConfirmPassword((prev) => !prev);
  };

  // Generate random password
  const generatePassword = () => {
    const randomPassword =
      Math.random().toString(36).slice(-12) +
      Math.random().toString(36).slice(-6);
    setFormData({
      ...formData,
      password: randomPassword,
      confirmPassword: randomPassword,
    });
    setErrorMessage("");
  };

  // Original validation function (for backward compatibility)
  const validateClientUnique = async (email, phoneNumber) => {
    try {
      const response = await apiCall("post", "/validate-client-unique", {
        email: email,
        phone_no: phoneNumber
      });
      
      return { isValid: true, message: "Email and phone are unique" };
    } catch (error) {
      const errorData = error.response?.data;
      
      if (errorData?.errors) {
        const errors = errorData.errors;
        let errorMessage = "";
        
        if (errors.email && errors.phone_no) {
          errorMessage = "Email and phone number are already registered";
        } else if (errors.email) {
          errorMessage = "Email is already registered";
        } else if (errors.phone_no) {
          errorMessage = "Phone number is already registered";
        }
        
        return { isValid: false, message: errorMessage };
      }
      
      return { 
        isValid: false, 
        message: errorData?.message || "Validation failed. Please try again." 
      };
    }
  };

  // Fetch products
  const fetchProducts = async () => {
    try {
      setProductsLoading(true);
      const response = await apiCall("get", "/get-all-products", null, navigate);

      console.log("Products API Response:", response);

      if (response?.data?.success && response?.data?.data) {
        setProducts(response.data.data);
        console.log("Products loaded:", response.data.data);
        
        if (response.data.data.length > 0) {
          setFormData({ ...formData, selectedProduct: response.data.data[0].product_id });
        }
        const handleRes = response.data;
        handleApiResponse(handleRes, "success", "GET");
      } else {
        console.log("Products fetch failed:", response);
        handleCustomResponse("error", "Failed to load products.");
      }
    } catch (error) {
      console.error("Products fetch error:", error);
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "GET");
    } finally {
      setProductsLoading(false);
    }
  };

  // Updated fetchPlans function to accept productId
  const fetchPlans = async (productId) => {
    if (!productId) return;
    try {
      setLoading(true);
      const response = await apiCall("get", `/get-pricing-plans-pev?product_id=${productId}`);

      if (response?.data?.data) {
        const fetchedPlans = response.data.data.map((plan) => ({
          plan_id: plan.plan_id,
          plan_name: plan.plan_name,
          plan_type: plan.plan_type,
          base_price: plan.base_price,
          created_by: plan.created_by,
          created_datetime: plan.created_datetime,
          customer_segment: plan.customer_segment,
          description: plan.description,
          is_active: plan.is_active,
          is_trial_plan: plan.is_trial_plan,
          max_vehicle_count: plan.max_vehicle_count,
          max_vehicles_allowed: plan.max_vehicles_allowed,
          min_vehicle_count: plan.min_vehicle_count,
          per_vehicle_fee: plan.per_vehicle_fee,
          volume_threshold: plan.volume_threshold,
        }));

        setPlans(fetchedPlans);
      } else {
        handleCustomResponse("error", "No pricing plans available for this product.");
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "GET");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setErrorMessage("");

      const clientData = new FormData();
      clientData.append("company_name", formData.companyName);
      clientData.append("client_name", formData.clientName);
      clientData.append("client_type", formData.clientType);
      clientData.append("plan_id", parseInt(formData.selectedPlan, 10));
      clientData.append("product_id", parseInt(formData.selectedProduct, 10));
      clientData.append("email", formData.email);
      clientData.append("phone_no", formData.phoneNumber);
      clientData.append("password", formData.password);
      if (formData.logo) {
        clientData.append("logo", formData.logo);
      }

      const response = await apiCall(
        "post",
        "/create-client",
        clientData,
        navigate,
        true
      );

      if (response?.data?.success) {
        const handleRes = response.data;
        handleApiResponse(handleRes, "success", "POST");
        nextStep();
      } else {
        handleCustomResponse("error", "Failed to create client.");
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "POST");
    } finally {
      setLoading(false);
    }
  };

  // Validate steps
  const validateStep = async (step) => {
    switch (step) {
      case 1: {
        const { companyName, clientName, email, phoneNumber, password, confirmPassword } = formData;
        
        // Basic validation first
        if (!companyName || !clientName || !email || !phoneNumber || !password) {
          handleCustomResponse("error", "Please fill all required fields.");
          return false;
        }
        
        if (!/^\S+@\S+\.\S+$/.test(email)) {
          handleCustomResponse("error", "Invalid email address.");
          return false;
        }
        
        if (!phoneNumber || phoneNumber.length < 8) {
          handleCustomResponse("error", "Please enter a valid phone number.");
          return false;
        }
        
        // Check real-time validation results
        if (validationResults.email.isValid === false) {
          handleCustomResponse("error", validationResults.email.message.replace("✗ ", ""));
          return false;
        }
        
        if (validationResults.phone.isValid === false) {
          handleCustomResponse("error", validationResults.phone.message.replace("✗ ", ""));
          return false;
        }
        
        // If still validating, wait a bit
        if (validationResults.email.validating || validationResults.phone.validating) {
          handleCustomResponse("info", "Please wait while we validate your information...");
          return false;
        }
        
        // If validation hasn't run yet, run it now
        if (validationResults.email.isValid === null) {
          await validateEmailUnique(email);
          if (validationResults.email.isValid === false) {
            handleCustomResponse("error", validationResults.email.message.replace("✗ ", ""));
            return false;
          }
        }
        
        if (validationResults.phone.isValid === null) {
          await validatePhoneUnique(phoneNumber);
          if (validationResults.phone.isValid === false) {
            handleCustomResponse("error", validationResults.phone.message.replace("✗ ", ""));
            return false;
          }
        }
        
        if (password.length < 6) {
          handleCustomResponse("error", "Password must be 6+ characters.");
          return false;
        }
        
        if (password !== confirmPassword) {
          handleCustomResponse("error", "Passwords do not match.");
          return false;
        }
        
        return true;
      }
      case 2:
        return true;
      case 3:
        if (!formData.selectedPlan || !formData.selectedProduct) {
          handleCustomResponse("error", "Select a product and plan.");
          return false;
        }
        return true;
      case 4:
        return true;
      default:
        return true;
    }
  };

  // Handle next step
  const handleNextStep = async () => {
    const isValid = await validateStep(currentStep);
    if (isValid) {
      if (currentStep === 4) setShowConfirmModal(true);
      else nextStep();
    }
  };

  // Confirm submission
  const confirmSubmission = () => {
    setShowConfirmModal(false);
    handleSubmit();
  };

  // Cleanup timers on unmount
  useEffect(() => {
    return () => {
      if (emailTimerRef.current) {
        clearTimeout(emailTimerRef.current);
      }
      if (phoneTimerRef.current) {
        clearTimeout(phoneTimerRef.current);
      }
    };
  }, []);

  // Fetch products and plans
  useEffect(() => {
    if (currentStep === 2 && products.length === 0) {
      fetchProducts();
    }
  }, [currentStep]);

  // Fetch plans when selectedProduct changes
  useEffect(() => {
    if (currentStep === 2 && formData.selectedProduct) {
      setPlans([]);
      setFormData({ ...formData, selectedPlan: null });
      fetchPlans(formData.selectedProduct);
    }
  }, [formData.selectedProduct, currentStep]);

  // Get logo preview or backend URL
  const getLogoPreview = () => {
    if (formData.logo instanceof File) {
      return URL.createObjectURL(formData.logo);
    } else if (formData.logo && typeof formData.logo === "string") {
      return `http://pevbackend.codovio.com/${formData.logo}`;
    }
    return "assets/images/user-list/user-list1.png";
  };

  return (
    <>
      <style>
        {`
        .container {
          width: 100% !important;
          max-width: 100% !important;
          padding-left: 15px;
          padding-right: 15px;
          margin: 0 auto;
        }
        .card {
          width: 100%;
          max-width: 100%;
        }
        .form-wizard {
          width: 100%;
        }
        @media (max-width: 576px) {
          .container {
            padding-left: 10px;
            padding-right: 10px;
          }
        }
        .modal-dialog {
          max-width: min(400px, 90vw) !important;
          margin: 1rem auto !important;
        }
        .pricing-plan {
          width: 100%;
        }
        .validation-message {
          font-size: 12px;
          margin-top: 4px;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .is-valid {
          border-color: #28a745 !important;
        }
        .is-invalid {
          border-color: #dc3545 !important;
        }
        .validating-spinner {
          display: inline-block;
          width: 12px;
          height: 12px;
          border: 2px solid #ccc;
          border-top-color: #007bff;
          border-radius: 50%;
          animation: spin 0.6s linear infinite;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        .real-time-feedback {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      `}
      </style>
      <div className="container">
        <div className="col">
          <div className="">
            <div className="card">
              <div className="card-body">
                <h6 className="mb-4 text-xl">Add New Client</h6>
                <p className="text-neutral-500">
                  Fill up your details and proceed next steps.
                </p>

                {/* Form Wizard Start */}
                <div className="form-wizard">
                  <form action="#" method="post">
                    <div className="form-wizard-header overflow-x-auto scroll-sm pb-8 my-32">
                      <ul className="list-unstyled form-wizard-list style-two">
                        <li
                          className={`form-wizard-list__item ${
                            [2, 3, 4].includes(currentStep) && "activated"
                          } ${currentStep === 1 && "active"} `}
                        >
                          <div className="form-wizard-list__line">
                            <span className="count">1</span>
                          </div>
                          <span className="text text-xs fw-semibold">
                            Basic Info
                          </span>
                        </li>
                        <li
                          className={`form-wizard-list__item ${
                            [3, 4].includes(currentStep) && "activated"
                          } ${currentStep === 2 && "active"} `}
                        >
                          <div className="form-wizard-list__line">
                            <span className="count">2</span>
                          </div>
                          <span className="text text-xs fw-semibold">
                            Select Plan
                          </span>
                        </li>
                        <li
                          className={`form-wizard-list__item ${
                            [4].includes(currentStep) && "activated"
                          } ${currentStep === 3 && "active"} `}
                        >
                          <div className="form-wizard-list__line">
                            <span className="count">3</span>
                          </div>
                          <span className="text text-xs fw-semibold">
                            Review
                          </span>
                        </li>
                        <li
                          className={`form-wizard-list__item ${
                            currentStep === 4 && "active"
                          } `}
                        >
                          <div className="form-wizard-list__line">
                            <span className="count">4</span>
                          </div>
                          <span className="text text-xs fw-semibold">
                            Completed
                          </span>
                        </li>
                      </ul>
                    </div>
                    {/* Step 1: Basic Information */}
                    <fieldset
                      className={`wizard-fieldset ${
                        currentStep === 1 && "show"
                      } `}
                    >
                      <h6 className="text-md text-neutral-500">
                        Basic Information
                      </h6>
                      <div className="row gy-3">
                        <div className="col-12">
                          <label className="form-label">Company Name*</label>
                          <div className="position-relative">
                            <input
                              type="text"
                              className="form-control wizard-required"
                              placeholder="Enter Company Name"
                              name="companyName"
                              value={formData.companyName}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="wizard-form-error" />
                          </div>
                        </div>
                        <div className="col-12">
                          <label className="form-label">Client Name*</label>
                          <div className="position-relative">
                            <input
                              type="text"
                              className="form-control wizard-required"
                              placeholder="Enter Client Name"
                              name="clientName"
                              value={formData.clientName}
                              onChange={handleInputChange}
                              required
                            />
                            <div className="wizard-form-error" />
                          </div>
                        </div>
                        <div className="col-12">
                          <label className="form-label">Email*</label>
                          <div className="position-relative">
                            <input
                              type="email"
                              className={`form-control wizard-required ${
                                validationResults.email.isValid === true ? 'is-valid' :
                                validationResults.email.isValid === false ? 'is-invalid' : ''
                              }`}
                              placeholder="Enter Email"
                              name="email"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {validationResults.email.validating && (
                              <div className="real-time-feedback">
                                <div className="validating-spinner"></div>
                              </div>
                            )}
                            {validationResults.email.isValid === true && !validationResults.email.validating && (
                              <div className="real-time-feedback text-success">
                                
                              </div>
                            )}
                            {validationResults.email.isValid === false && !validationResults.email.validating && (
                              <div className="real-time-feedback text-danger">
                                
                              </div>
                            )}
                            <div className="wizard-form-error" />
                          </div>
                          {validationResults.email.message && (
                            <div className={`validation-message ${
                              validationResults.email.isValid === true ? 'text-success' :
                              validationResults.email.isValid === false ? 'text-danger' : 'text-muted'
                            }`}>
                              {validationResults.email.validating ? (
                                <>
                                  <div className="validating-spinner"></div>
                                  Checking email availability...
                                </>
                              ) : (
                                validationResults.email.message
                              )}
                            </div>
                          )}
                        </div>
                        <div className="col-12">
                          {/* <label className="form-label">Phone Number*</label> */}
                          <div className="position-relative">
                            <CustomPhoneInput
                              name="phoneNumber"
                              control={control}
                              errors={errors}
                              defaultCountry="pk"
                              placeholder="Enter phone number"
                              value={formData.phoneNumber}
                              onChange={handlePhoneChange}
                              className={`w-100 ${
                                validationResults.phone.isValid === true ? 'is-valid' :
                                validationResults.phone.isValid === false ? 'is-invalid' : ''
                              }`}
                            />
                            {validationResults.phone.validating && (
                              <div className="real-time-feedback">
                                <div className="validating-spinner"></div>
                              </div>
                            )}
                            {validationResults.phone.isValid === true && !validationResults.phone.validating && (
                              <div className="real-time-feedback text-success">
                                
                              </div>
                            )}
                            {validationResults.phone.isValid === false && !validationResults.phone.validating && (
                              <div className="real-time-feedback text-danger">
                                
                              </div>
                            )}
                          </div>
                          {validationResults.phone.message && (
                            <div className={`validation-message mt-1 ${
                              validationResults.phone.isValid === true ? 'text-success' :
                              validationResults.phone.isValid === false ? 'text-danger' : 'text-muted'
                            }`}>
                              {validationResults.phone.validating ? (
                                <>
                                  <div className="validating-spinner"></div>
                                  Checking phone availability...
                                </>
                              ) : (
                                validationResults.phone.message
                              )}
                            </div>
                          )}
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">Password*</label>
                          <div className="position-relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control wizard-required pr-16"
                              placeholder="Enter Password"
                              name="password"
                              value={formData.password}
                              onChange={handleInputChange}
                              required
                            />
                            <span
                              onClick={generatePassword}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#666",
                              }}
                            >
                              <Key size={18} />
                            </span>
                            <span
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                              style={{
                                position: "absolute",
                                right: "40px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#666",
                              }}
                            >
                              {showPassword ? (
                                <EyeOff size={18} />
                              ) : (
                                <Eye size={18} />
                              )}
                            </span>
                            <div className="wizard-form-error" />
                          </div>
                          <small className="">
                            Password should be 6 characters long
                          </small>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">
                            Confirm Password*
                          </label>
                          <div className="position-relative">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              className="form-control wizard-required pr-10"
                              placeholder="Confirm Password"
                              name="confirmPassword"
                              value={formData.confirmPassword}
                              onChange={handleInputChange}
                              required
                            />
                            <span
                              onClick={() =>
                                togglePasswordVisibility("confirmPassword")
                              }
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#666",
                              }}
                            >
                              {showConfirmPassword ? (
                                <EyeOff size={18} />
                              ) : (
                                <Eye size={18} />
                              )}
                            </span>
                            <div className="wizard-form-error" />
                          </div>
                        </div>
                        <div className="col-12">
                          <label className="form-label">Logo (Optional)</label>
                          <div className="position-relative">
                            <input
                              type="file"
                              className="form-control wizard-required"
                              accept="image/*"
                              onChange={handleFileChange}
                            />
                            <div className="wizard-form-error" />
                          </div>
                          {formData.logo && (
                            <div className="mt-2">
                              <p className="text-neutral-500 small mb-2">
                                Selected: {formData.logo.name}
                              </p>
                              <img
                                src={getLogoPreview()}
                                alt="Logo Preview"
                                style={{
                                  maxWidth: "150px",
                                  maxHeight: "150px",
                                  borderRadius: "8px",
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="form-group text-end">
                          <button
                            onClick={handleNextStep}
                            type="button"
                            className="form-wizard-next-btn btn btn-primary-600 px-32"
                            disabled={loading || validationResults.email.validating || validationResults.phone.validating}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </fieldset>
                    {/* Step 2: Select Product & Plan */}
                    <fieldset
                      className={`wizard-fieldset ${
                        currentStep === 2 && "show"
                      } `}
                    >
                      <h6 className="text-md text-neutral-500">Select Plan</h6>
                      <div className="row gy-3">
                       <div className="col-12">
                          <label className="form-label">Select Product*</label>
                          <div className={errorMessage ? "is-invalid" : ""}>
                            <CustomSelect
                              name="selectedProduct"
                              value={
                                formData.selectedProduct
                                  ? products.find(p => p.product_id === formData.selectedProduct)
                                    ? { 
                                        label: products.find(p => p.product_id === formData.selectedProduct)?.product_name, 
                                        value: formData.selectedProduct 
                                      }
                                    : null
                                  : null
                              }
                              onChange={(selectedOption) => {
                                handleInputChange({
                                  target: { name: "selectedProduct", value: selectedOption?.value || "" }
                                });
                              }}
                              options={products.map(product => ({
                                label: product.product_name,
                                value: product.product_id,
                                raw: product
                              }))}
                              placeholder="Select a product"
                              labelKey="label"
                              valueKey="value"
                              isClearable={false}
                              isSearchable={true}
                              isLoading={productsLoading || loading}
                            />
                            {errorMessage && (
                              <span className="text-danger-600 d-block mt-1">{errorMessage}</span>
                            )}
                          </div>
                        </div>
                        {productsLoading ? (
                          <div className="text-center my-4">
                            {/* <LoadingComponent /> */}
                          </div>
                        ) : loading ? (
                          <div className="text-center my-4">
                            {/* <LoadingComponent /> */}
                          </div>
                        ) : plans.length === 0 ? (
                          <div className="alert alert-warning" role="alert">
                            No plans available for this product. Select another product or contact support.
                          </div>
                        ) : (
                          plans.map((plan) => (
                            <div
                              className="col-xxl-4 col-sm-6"
                              key={plan.plan_id}
                            >
                              <div
                                className={`pricing-plan position-relative radius-24 overflow-hidden border 
                              ${
                                formData.selectedPlan === plan.plan_id
                                  ? "bg-primary-600 text-white"
                                  : "bg-base"
                              }`}
                                onClick={() => handlePlanSelect(plan.plan_id)}
                                style={{
                                  cursor: "pointer",
                                  transition: "0.3s",
                                }}
                              >
                                {formData.selectedPlan === plan.plan_id && (
                                  <span className="bg-white bg-opacity-25 text-white radius-24 py-8 px-24 text-sm position-absolute end-0 top-0 z-1 rounded-start-top-0 rounded-end-bottom-0">
                                    Selected
                                  </span>
                                )}

                                <div className="d-flex align-items-center gap-16 p-24">
                                  <span
                                    className={`w-72-px h-72-px d-flex justify-content-center align-items-center radius-16 
                                ${
                                  formData.selectedPlan === plan.plan_id
                                    ? "bg-base"
                                    : "bg-primary-50"
                                }`}
                                  >
                                    <img
                                      src="/assets/images/pricing/price-icon4.png"
                                      alt="plan-icon"
                                    />
                                  </span>
                                  <div>
                                    <span
                                      className={`fw-medium text-md ${
                                        formData.selectedPlan === plan.plan_id
                                          ? "text-white"
                                          : "text-secondary-light"
                                      }`}
                                    >
                                      {plan.plan_type}
                                    </span>
                                    <h6
                                      className={`mb-0 ${
                                        formData.selectedPlan === plan.plan_id
                                          ? "text-white"
                                          : ""
                                      }`}
                                    >
                                      {plan.plan_name}
                                    </h6>
                                  </div>
                                </div>

                                <div className="px-24">
                                  <p
                                    className={`mt-16 mb-0 ${
                                      formData.selectedPlan === plan.plan_id
                                        ? "text-white"
                                        : "text-secondary-light"
                                    } mb-28`}
                                  >
                                    {plan.description ||
                                      "No description available."}
                                  </p>

                                  <h3
                                    className={`mb-24 ${
                                      formData.selectedPlan === plan.plan_id
                                        ? "text-white"
                                        : ""
                                    }`}
                                  >
                                    ${plan.base_price}{" "}
                                    <span
                                      className={`fw-medium text-md ${
                                        formData.selectedPlan === plan.plan_id
                                          ? "text-white"
                                          : "text-secondary-light"
                                      }`}
                                    >
                                      /monthly
                                    </span>
                                  </h3>

                                  <span
                                    className={`mb-20 fw-medium ${
                                      formData.selectedPlan === plan.plan_id
                                        ? "text-white"
                                        : ""
                                    }`}
                                  >
                                    Plan Details
                                  </span>
                                  <ul className="mt-2">
                                    {[
                                      { label: "Plan ID", value: plan.plan_id },
                                      {
                                        label: "Created By",
                                        value: plan.created_by,
                                      },
                                      {
                                        label: "Created Date",
                                        value: plan.created_datetime,
                                      },
                                      {
                                        label: "Customer Segment",
                                        value: plan.customer_segment,
                                      },
                                      {
                                        label: "Active",
                                        value: plan.is_active ? "Yes" : "No",
                                      },
                                      {
                                        label: "Trial Plan",
                                        value: plan.is_trial_plan
                                          ? "Yes"
                                          : "No",
                                      },
                                      {
                                        label: "Max Vehicle Count",
                                        value: plan.max_vehicle_count,
                                      },
                                      {
                                        label: "Max Vehicles Allowed",
                                        value: plan.max_vehicles_allowed,
                                      },
                                      {
                                        label: "Min Vehicle Count",
                                        value: plan.min_vehicle_count,
                                      },
                                      {
                                        label: "Per Vehicle Fee",
                                        value: plan.per_vehicle_fee
                                          ? `$${plan.per_vehicle_fee}`
                                          : "N/A",
                                      },
                                      {
                                        label: "Volume Threshold",
                                        value: plan.volume_threshold || "N/A",
                                      },
                                    ].map((item, idx) => (
                                      <li
                                        key={idx}
                                        className="d-flex align-items-center gap-16 mb-12 text-lg"
                                      >
                                        <span
                                          className={`w-24-px h-24-px d-flex justify-content-center align-items-center rounded-circle 
                                      ${
                                        formData.selectedPlan === plan.plan_id
                                          ? "bg-white text-primary-600"
                                          : "bg-primary-600 text-white"
                                      }`}
                                        >
                                          <i className="bi bi-check"></i>
                                        </span>
                                        <span
                                          className={`${
                                            formData.selectedPlan ===
                                            plan.plan_id
                                              ? "text-white"
                                              : "text-secondary-light"
                                          } text-sm`}
                                        >
                                          <strong>{item.label}:</strong>{" "}
                                          {item.value}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                        <div className="form-group d-flex align-items-center justify-content-end gap-8">
                          <button
                            onClick={prevStep}
                            type="button"
                            className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32"
                            disabled={loading || productsLoading}
                          >
                            Back
                          </button>
                          <button
                            onClick={handleNextStep}
                            type="button"
                            className="form-wizard-next-btn btn btn-primary-600 px-32"
                            disabled={!formData.selectedPlan || loading || productsLoading}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </fieldset>
                    {/* Step 3: Review */}
                    <fieldset
                      className={`wizard-fieldset ${
                        currentStep === 3 && "show"
                      } `}
                    >
                      <h6 className="text-md text-neutral-500">
                        Review Information
                      </h6>
                      <div className="row gy-3">
                        <div className="col-12">
                          <div className="card border-neutral-100">
                            <div className="card-body">
                              <h6 className="text-md text-neutral-500">
                                Basic Information
                              </h6>
                              <div className="row mb-2">
                                <div className="col-6 text-neutral-500">
                                  Company Name:
                                </div>
                                <div className="col-6">
                                  {formData.companyName}
                                </div>
                              </div>
                              <div className="row mb-2">
                                <div className="col-6 text-neutral-500">
                                  Client Name:
                                </div>
                                <div className="col-6">
                                  {formData.clientName}
                                </div>
                              </div>
                              <div className="row mb-2">
                                <div className="col-6 text-neutral-500">
                                  Email:
                                </div>
                                <div className="col-6">
                                  {formData.email}
                                  {validationResults.email.isValid === true && (
                                    <span className="text-success ms-2">✓ Verified</span>
                                  )}
                                </div>
                              </div>
                              <div className="row mb-2">
                                <div className="col-6 text-neutral-500">
                                  Phone Number:
                                </div>
                                <div className="col-6">
                                  {formData.phoneNumber}
                                  {validationResults.phone.isValid === true && (
                                    <span className="text-success ms-2">✓ Verified</span>
                                  )}
                                </div>
                              </div>
                              <div className="row mb-2">
                                <div className="col-6 text-neutral-500">
                                  Client Type:
                                </div>
                                <div className="col-6">
                                  {formData.clientType === "corporate"
                                    ? "Corporate"
                                    : "Individual"}
                                </div>
                              </div>
                              <div className="row mb-2">
                                <div className="col-6 text-neutral-500">
                                  Logo:
                                </div>
                                <div className="col-6">
                                  {formData.logo ? (
                                    <img
                                      src={getLogoPreview()}
                                      alt="Logo Preview"
                                      style={{
                                        maxWidth: "150px",
                                        maxHeight: "150px",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  ) : (
                                    "None"
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="card border-neutral-100">
                            <div className="card-body">
                              <h6 className="text-md text-neutral-500">
                                Selected Product & Plan
                              </h6>
                              {formData.selectedProduct && (
                                <>
                                  <div className="row mb-2">
                                    <div className="col-6 text-neutral-500">
                                      Product Name:
                                    </div>
                                    <div className="col-6">
                                      {
                                        products.find(
                                          (p) =>
                                            p.product_id === formData.selectedProduct
                                        )?.product_name
                                      }
                                    </div>
                                  </div>
                                </>
                              )}
                              {formData.selectedPlan && (
                                <>
                                  <div className="row mb-2">
                                    <div className="col-6 text-neutral-500">
                                      Plan Name:
                                    </div>
                                    <div className="col-6">
                                      {
                                        plans.find(
                                          (p) =>
                                            p.plan_id === formData.selectedPlan
                                        )?.plan_name
                                      }
                                    </div>
                                  </div>
                                  <div className="row mb-2">
                                    <div className="col-6 text-neutral-500">
                                      Price:
                                    </div>
                                    <div className="col-6">
                                      $
                                      {
                                        plans.find(
                                          (p) =>
                                            p.plan_id === formData.selectedPlan
                                        )?.base_price
                                      }
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="form-group d-flex align-items-center justify-content-end gap-8">
                          <button
                            onClick={prevStep}
                            type="button"
                            className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32"
                            disabled={loading}
                          >
                            Back
                          </button>
                          <button
                            onClick={handleNextStep}
                            type="button"
                            className="form-wizard-next-btn btn btn-primary-600 px-32"
                            disabled={loading}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </fieldset>
                    {/* Step 4: Completed */}
                    <fieldset
                      className={`wizard-fieldset ${
                        currentStep === 4 && "show"
                      } `}
                    >
                      <div className="text-center mb-40">
                        <img
                          src="assets/images/gif/success-img3.gif"
                          alt="Client Added"
                          className="gif-image mb-24"
                        />
                        <h6 className="text-md text-neutral-600">
                          Congratulations
                        </h6>
                        <p className="text-neutral-400 text-sm mb-0">
                          Client added successfully!
                        </p>
                      </div>
                      <div className="form-group d-flex align-items-center justify-content-end gap-8">
                        <Link to="/">
                          <button
                            type="button"
                            className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32"
                          >
                            Dashboard
                          </button>
                        </Link>
                        <Link to="/all-clients">
                          <button
                            type="button"
                            className="form-wizard-submit btn btn-primary-600 px-32"
                          >
                            Client List
                          </button>
                        </Link>
                      </div>
                    </fieldset>
                  </form>
                </div>
                {/* Form Wizard End */}
              </div>
            </div>
            {/* Confirmation Modal */}
            <div
              className={`modal fade ${showConfirmModal ? "show d-block" : ""}`}
              style={{
                background: showConfirmModal ? "rgba(0,0,0,0.5)" : "none",
              }}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Submission</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowConfirmModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    Are you sure you want to submit? Please review all details.
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-neutral-500 border-neutral-100"
                      onClick={() => setShowConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary-600"
                      onClick={confirmSubmission}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Loading Overlay */}
            {(loading || validationResults.email.validating || validationResults.phone.validating) && (
              <div
                className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                style={{ background: "rgba(0,0,0,0.6)", zIndex: 9999 }}
              >
                <LoadingComponent />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddClient;